// extracted by mini-css-extract-plugin
export default {"usageTable":"UsageModal_usageTable__gRHDi"};